var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationMyElectricitySupply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4873 2L9.97019 9.39933L2 10.624L7.58645 16.1167L6.36533 23.9707L13.3264 20.546L20.2364 24L19.1249 16.3L24.7333 10.756L16.9825 9.59L13.4873 2Z",
    stroke: "#6A6A6A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.458 2.10278V20.5461",
    stroke: "#6A6A6A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58594 16.1165L13.4356 13.3592L16.982 9.58984",
    stroke: "#6A6A6A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9707 9.39941L13.4366 13.3594L19.1255 16.3001",
    stroke: "#6A6A6A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5215 10.8073L13.4363 13.3593L2.13184 10.646",
    stroke: "#6A6A6A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42383 23.736L13.4361 13.3594L20.1267 23.868",
    stroke: "#6A6A6A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationMyElectricitySupply);
export default __webpack_public_path__ + "static/media/navigation-my-electricity-supply.a4846186423bb68666aabfae175bc4b6.svg";
export { ForwardRef as ReactComponent };